var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var setScoresToCompanies = function (companies, stages, scores) {
    return companies.map(function (company) {
        var companyScores = scores.filter(function (score) { return score.referenceId === company.id; });
        return __assign(__assign({}, company), { scores: stages.map(function (stage) {
                var _a, _b, _c, _d;
                var relevantStageScores = companyScores.find(function (score) { return score.stageId === stage.id; });
                return {
                    stageId: stage.id,
                    stageName: stage.stageName,
                    income: (_a = relevantStageScores === null || relevantStageScores === void 0 ? void 0 : relevantStageScores.income) !== null && _a !== void 0 ? _a : 0,
                    expense: (_b = relevantStageScores === null || relevantStageScores === void 0 ? void 0 : relevantStageScores.expenses) !== null && _b !== void 0 ? _b : 0,
                    balance: (_c = relevantStageScores === null || relevantStageScores === void 0 ? void 0 : relevantStageScores.endBalance) !== null && _c !== void 0 ? _c : 0,
                    startingBalance: (_d = company.startingBalance) !== null && _d !== void 0 ? _d : 0
                };
            }) });
    });
};
export var getAllCompanyTotals = function (company) {
    var scores = company.scores;
    var getTotalValue = function (key) {
        return scores.reduce(function (accumulator, score) {
            return accumulator + score[key];
        }, 0);
    };
    return {
        income: getTotalValue('income'),
        expense: getTotalValue('expense'),
        balance: getTotalValue('balance')
    };
};
export var getCompanyScoresInASingleStage = function (scores, stageId) {
    var _a = scores.find(function (score) { return score.stageId === stageId; }), income = _a.income, expense = _a.expense, balance = _a.balance;
    return {
        income: income,
        expense: expense,
        balance: balance
    };
};
